import React from 'react';
import { Box, Typography } from '@mui/material';
import { RichTextEditor } from '../../RichTextEditor/RichTextEditor';

const navy = '#1e3a5f';

/**
 * TextContentStep
 * עריכת תוכן טקסט חופשי (TextWidget)
 *
 * Props:
 *   formData  { text: string (HTML) }
 *   onChange  (partial) => void
 */
const TextContentStep = ({ formData, onChange }) => {
  const text = formData?.text || '';

  return (
    <Box dir="rtl">
      <Typography sx={{ fontWeight: 700, color: navy, fontSize: '1rem', mb: 0.5 }}>
        תוכן
      </Typography>
      <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', mb: 2.5, lineHeight: 1.5 }}>
        הכנס את התוכן שיוצג ברכיב. ניתן לעצב את הטקסט בעזרת הכלים בסרגל.
      </Typography>

      <RichTextEditor
        initialHtml={text}
        onChange={(html) => onChange({ text: html })}
      />
    </Box>
  );
};

export default TextContentStep;
